/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateTransactionReversal} from '../api'

export const useMutationInitiateTransactionReversal = createReactQueryMutationHook('initiateTransactionReversal', initiateTransactionReversal)
